
  var rt = require("@stylable/runtime/dist/css-runtime-stylesheet.js");

  module.exports = rt.create(
      "IconButton2315567116",
      {"classes":{"root":"IconButton2315567116__root","icon":"IconButton2315567116__icon","skin-line":"IconButton2315567116__skin-line","skin-full":"IconButton2315567116__skin-full"},"vars":{"wix-ui-tpa-icon-button-icon-color":"--wix-ui-tpa-icon-button-icon-color","wix-ui-tpa-icon-button-background-color":"--wix-ui-tpa-icon-button-background-color"},"stVars":{"DefaultColor":"color-5","DefaultBackgroundColor":"color-1","DisabledColor":"color-3","IconColor":"--overridable","BackgroundColor":"--overridable"},"keyframes":{},"layers":{}},
      "",
      -1,
      module.id
  );
  